import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/useTranslation";

interface CeremonyFormFieldsProps {
  date: string;
  time: string;
  locationName: string;
  address: string;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
  onLocationNameChange: (value: string) => void;
  onAddressChange: (value: string) => void;
  className?: string;
}

export function CeremonyFormFields({
  date,
  time,
  locationName,
  address,
  onDateChange,
  onTimeChange,
  onLocationNameChange,
  onAddressChange,
  className,
}: CeremonyFormFieldsProps) {
  const { t } = useTranslation();
  return (
    <div className={cn("space-y-4", className)}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="ceremony-date">{t("common.date")}</Label>
          <Input
            id="ceremony-date"
            type="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="ceremony-time">{t("events.form.details.time")}</Label>
          <Input
            id="ceremony-time"
            type="time"
            value={time}
            onChange={(e) => onTimeChange(e.target.value)}
            className="mt-1"
          />
        </div>
      </div>
      <div>
        <Label htmlFor="ceremony-location">{t("events.form.details.locationName")}</Label>
        <Input
          id="ceremony-location"
          value={locationName}
          onChange={(e) => onLocationNameChange(e.target.value)}
          className="mt-1"
        />
      </div>
      <div>
        <Label htmlFor="ceremony-address">{t("events.form.details.address")}</Label>
        <Input
          id="ceremony-address"
          value={address}
          onChange={(e) => onAddressChange(e.target.value)}
          className="mt-1"
        />
      </div>
    </div>
  );
}

